"use strict";

/**
 * @function
 * @description
 */

const initCustomTooltip = () => {
    $("body").on("click", ".js-custom-tooltip", e => {
        var $tooltipBtn = $(e.currentTarget);
        var content = $tooltipBtn.find(".tooltip-inner span");

        $tooltipBtn.find(".c-custom-tooltip__content").toggleClass("hide").toggleClass("show");
        trancateTooltipContent(content);
    });
};

/**
 * Parses a string which contains any html tag and return a new string without them
 *
 * @param {String} inputstr The string
 *
 * @return {String} String without html tags
 */
function removeTags(inputstr) {
    let str = inputstr;
    if ((str===null) || (str==="")) {
        return false;
    } else {
        str = str.toString();
    }
    // Regular expression to identify HTML tags in
    // the input string. Replacing the identified
    // HTML tag with a null string.
    return str.replace(/(<([^>]+)>)/ig, "");
}

const trancateTooltipContent = (content) => {
    // Assigning the content jquery object not to search for it again
    var $content = $(content);
    let contentText =removeTags($content.html()).trim();
    var length = contentText.length;
    // Getting the length else we are putting default value as 90;
    var maxChars = parseInt($content.data("maxlength"), 10) || 90;
    if (length > maxChars) {
        var trancatedText = contentText.slice(0, maxChars) + "...";
        $content.html(trancatedText);
    } else {
        $content.html(content.html() + "...");
    }
};

module.exports = initCustomTooltip;
